import {
  FETCH_TOTAL_GREEN_FACTOR_REQUEST,
  FETCH_TOTAL_GREEN_FACTOR_SUCCESS,
  FETCH_TOTAL_GREEN_FACTOR_FAILURE,
} from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const totalGreenFactorTodayReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_TOTAL_GREEN_FACTOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TOTAL_GREEN_FACTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_TOTAL_GREEN_FACTOR_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default totalGreenFactorTodayReducer;
